import InstagramEmbedPost from '@cohort/components-xps/components/apps/instagram/InstagramEmbedPost';
import type {InstagramCommentMediaTriggerStruct} from '@cohort/shared/apps/instagram/triggers/commentMedia';
import serializeDataAttributes from '@cohort/shared-frontend/utils/serializeDataAtttributes';
import type {DetailsComponentProps} from '@cohort/wallet/apps/TriggerIntegration';

const InstagramCommentMediaTriggerIntegrationDetailsComponent: React.FC<
  DetailsComponentProps<InstagramCommentMediaTriggerStruct>
> = ({config, stepId, triggerId}) => (
  <div
    className="flex w-full items-center justify-center"
    {...serializeDataAttributes({
      'step-id': stepId,
      'trigger-id': triggerId,
    })}
  >
    <InstagramEmbedPost postUrl={config.mediaPermalink} />
  </div>
);

export default InstagramCommentMediaTriggerIntegrationDetailsComponent;
